import { Component, computed, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WebsiteData } from '../../../../shared/models/website-overview.model';
import { BytesToSizePipe } from '../../../../shared/pipes/bytes-to-size-pipe';

@Component({
  selector: 'app-bandwidth',
  imports: [MatCardModule, MatProgressSpinnerModule, BytesToSizePipe],
  templateUrl: './bandwidth.component.html',
  styleUrl: './bandwidth.component.scss',
})
export class BandwidthComponent {
  websiteData = input.required<WebsiteData>();

  currentUsage = computed(() => this.websiteData().bandwidthUsage?.totalUsage);

  bandwidthLimit = computed(() => this.websiteData().hostingPlan?.monthlyBandwidthLimit);

  bandwidthPercent = computed(() => {
    const usage = this.currentUsage();
    const limit = this.bandwidthLimit();
    if (usage && limit) return Math.round((usage / limit) * 10000) / 100;
    return 0;
  });
}
